import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { BFC } from '@/shared/types';
import { Title } from '@/shared/uikit/Title';

export const PageTitle: BFC = ({ children }) => {
  return (
    <TitleStyled bold size={28}>
      {children}
    </TitleStyled>
  );
};

const TitleStyled = styled(Title)`
  font-size: 28px;

  ${media.md}, ${breakpoints.sm} {
    font-size: 18px !important;
  }
`;
